import { createContext } from 'react';

import {
  QRUserRole,
  StatusFilter,
} from '@totem/components/services/remoteAccess/v2/users/types';

interface Context {
  loading: boolean;
  buildingId: string;
  buildingName: string;
  canView: boolean;
  canEdit: boolean;
  rows: QRUserRole[];
  emailSearch: string;
  setEmailSearch: (value: string) => void;
  nameSearch: string;
  setNameSearch: (value: string) => void;
  statusFilter: StatusFilter;
  setStatusFilter: (value: StatusFilter) => void;
  selectedUserIds: string[];
  setSelectedUserIds: (value: string[]) => void;
  onRefresh: () => void;
}

export default createContext<Context>({
  loading: false,
  buildingId: '',
  buildingName: '',
  canView: false,
  canEdit: false,
  rows: [],
  emailSearch: '',
  setEmailSearch: () => {},
  nameSearch: '',
  setNameSearch: () => {},
  statusFilter: 'all',
  setStatusFilter: () => {},
  selectedUserIds: [],
  setSelectedUserIds: () => {},
  onRefresh: () => {},
});
